<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <input
                type="number"
                :id="getId"
                class="form-control"
                v-model="currentValue"
        />
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo
        ],
    }
</script>
